import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import Button from '@material-ui/core/Button';
import BulkEditExpression from '../arcgisFilter/containers/BulkEditExpression';
import fieldsDefinition from './bulkEditFields.json';
import { incidentsOperations } from '../../redux/incidentList';
import { userOperations } from '../../redux/user';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import originFields from '../../defaults/PointOfOriginFields.json'
import CircularProgress from '@material-ui/core/CircularProgress';
import theme from '../../muiTheme';
import Snackbar from '@mui/material/Snackbar';

class BulkEditDialog extends Component {

  constructor (props)
  {
    super(props);
 
    this.state =
    {   isSaving: false,
        showSnackbar: false,
        expression: {
            field: null,
            operator: '=',
            value: {
              name: '',
              code: ''
            },
            valueType: 'value'
          }
    };
  }


  handleUpdateExpression = (expression) => {
    this.setState({
        expression: expression
      });
  }
  
  saveEdit = () => {
    this.setState({
      isSaving: true
    });
    const ids = this.props.incidents.map(x => x.attributes[originFields.fireOccurenceRecordID]);
    window.api.bulkEditIncidents(ids, this.state.expression.field.name, this.state.expression.value.code).then(response => {

      this.setState({
        isSaving: false,
        showSnackbar: true
      });
    });
  }

  render() {

    const updateButton = (this.state.isSaving) ? (  <CircularProgress size={24} thickness={2} color={theme.palette.primary1Color} />) : (<Button
    className="reporting-print-btn"
    variant="contained" color="primary"
    disabled={this.state.expression.field === null || this.state.expression.value === null} 
    onClick={this.saveEdit}>Bulk Update Records</Button>);
    const actions = [updateButton,
      <Button
        className="reporting-print-btn"
        onClick={this.props.onClose}>Close</Button>
    ];
    const incidentLength = (this.props.incidents) ? this.props.incidents.length : '';
    return (
      <Dialog
        open={this.props.open}
        actions={actions}
        modal={true}
        autoScrollBodyContent={true}
        PaperProps={{
            sx: {
              minHeight: '80%',
              maxHeight: '80%'
            }
          }}>
            Select the attribute you'd like to update and the new value to be assigned.
            <p><b>NOTE:</b> Changes will be applied to all {incidentLength} incidents currently defined by your filter parameters, not just the ones in the visible map extent.</p>
            <Table style={{height: "500px"}}>
            <TableBody style={{width: "500px"}}>
            <TableRow>
            <BulkEditExpression
                disableUnique={true}
                removeDelete={true}
                overrideStringOperators={true}
                operatorOverrideType="equals"
                fields={fieldsDefinition}
                updateExpression={this.handleUpdateExpression}
                expressionDef={this.state.expression}
                />
            </TableRow>
        </TableBody>
        </Table>
        <Snackbar
          open={this.state.showSnackbar}
          message="Incidents updated"
          autoHideDuration={2000}
          onClose={() => this.setState({showSnackbar: false})}
        />
      </Dialog>
    )
  }
}

const mapStateToProps = state => ({
  user: state.user,
  incidentList: state.incidentList
})


const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
      ...userOperations,
      ...incidentsOperations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(BulkEditDialog)
